// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_a-1";
export var movingGradient = "_a-4";
export var movingGradientBlock = "_a-2";
export var skeleton = "_a-0";
export var skeletonText = "_a-3";